import { Grid, Paper, Typography } from '@mui/material';

export const FirstPolicy = () => {
    return (
        <Paper square sx={{ backgroundColor: '#1976d2', margin: 1 }}>
            <Grid container direction="column" px={2} pb={2} spacing={2}>
                <Grid item container justifyContent="center">
                    <Typography variant="h6" color="white">
                        スマイル指導（怒る指導なし）
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography variant="body2" color="white">説得から納得へ！</Typography>
                    <Typography variant="body2" color="white">子ども自ら意欲を高め、個性を伸ばせるような指導に努めます</Typography>
                </Grid>
            </Grid>
        </Paper>
    )
}
